import {
  ProjectTeamStateTypes,
  ProjectTeamActionTypes,
} from "./ProjectTeam.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProjectTeamStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ProjectTeamReducer = (
  state: ProjectTeamStateTypes = INITIAL_STATE,
  action: any
): ProjectTeamStateTypes => {
  switch (action.type) {
    case ProjectTeamActionTypes.FETCH_ALL_PROJECT_TEAM:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectTeamActionTypes.FETCH_ALL_PROJECT_TEAM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectTeamActionTypes.FETCH_ALL_PROJECT_TEAM_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectTeamActionTypes.FETCH_ALL_PROJECT_TEAM_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ProjectTeamActionTypes.FETCH_ONE_PROJECT_TEAM:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectTeamActionTypes.FETCH_ONE_PROJECT_TEAM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case ProjectTeamActionTypes.FETCH_ONE_PROJECT_TEAM_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectTeamActionTypes.FETCH_ONE_PROJECT_TEAM_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProjectTeamReducer;
